module.exports = __webpack_public_path__ + "img/weddingrings-mobile@2x.9603b16.jpg";